"use es6";

import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import AWS from "aws-sdk";

import "../../style/global.css";

const S3_BUCKET = "sfh-reports";
const REGION = "us-east-1";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_S3_ACCESS_KEY_ID,
  secretAccessKey: process.env.REACT_APP_S3_SECRET_ACCESS_KEY,
});

const myBucket = new AWS.S3({
  params: { Bucket: S3_BUCKET },
  region: REGION,
});

const DropdownButton = ({
  credentials,
  color,
  company,
  type = null,
  children = "[insert text]",
  style = {},
  options = {},
  ...buttonProps
}) => {
  const [progress, setProgress] = useState(0);
  const [dropdownVisible, setDropdownVisible] = useState(false);
  const [showForm, setShowForm] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploading, setUploading] = useState(false);
  const [year, setYear] = useState("");

  const wrapperRef = useRef(null);

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
        setDropdownVisible(false);
      }
    };

    if (dropdownVisible) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownVisible]);

  style = {
    borderRadius: 8,
    borderWidth: 0,
    color: "#ffffff",
    paddingRight: 20,
    paddingLeft: 20,
    paddingTop: 10,
    paddingBottom: 10,
    textAlign: "center",
    maxHeight: 20,
    fontWeight: 600,
    margin: style.margin,
    ...style,
  };

  const requestConfig = {
    headers: {
      "x-api-key": process.env.REACT_APP_API_KEY,
    },
  };

  const uploadFile = (file, name) => {
    const params = {
      ACL: "public-read",
      Body: file,
      Bucket: S3_BUCKET,
      Key: `${name}.pdf`,
      ContentType: "application/pdf",
    };

    myBucket
      .putObject(params)
      .on("httpUploadProgress", (evt) => {
        setProgress(Math.round((evt.loaded / evt.total) * 100));
      })
      .send((err) => {
        if (err) {
          console.error("Upload error:", err);
        } else {
          alert("Report uploaded successfully!");
          setShowForm(false);
          setUploading(false);
          callExtractAPI(`${name}.pdf`);
        }
      });
  };

  const callExtractAPI = async (s3Key) => {
    try {
      const res = await axios.post(
        `${process.env.REACT_APP_EXTRACTS_API_URL}/extracts`,
        {
          s3_key: s3Key,
          report_type: type,
          historical_data: JSON.stringify(company.reportdata),
          admin: credentials.admin === "valid",
        },
        requestConfig
      );
      console.log("Extracted data:", res.data);
    } catch (err) {
      console.error("Error extracting PDF:", err);
    }
  };

  const handleUpload = () => {
    if (!selectedFile || !year) {
      alert("Please select a file and enter a year.");
      return;
    }
    const name = `${company.slug}_${year}_${Date.now()}`;
    setUploading(true);
    uploadFile(selectedFile, name);
    setSelectedFile(null);
    setProgress(0);
    setYear("");
  };

  return (
    <div
      ref={wrapperRef}
      style={{
        position: "relative",
        display: "inline-block",
        minWidth: 220,
      }}
    >
      <div
        style={{ cursor: "pointer", ...style }}
        {...buttonProps}
        onClick={() => setDropdownVisible((prev) => !prev)}
        onMouseOver={({ currentTarget }) => {
          if (!showForm) currentTarget.style.opacity = "50%";
        }}
        onMouseOut={({ currentTarget }) => {
          if (!showForm) currentTarget.style.opacity = "100%";
        }}
      >
        {children}
      </div>

      {dropdownVisible && (
        <div
          style={{
            display: "flex",
            flexDirection: "column",
            position: "absolute",
            backgroundColor: "#ffffff",
            borderRadius: 8,
            width: 200,
            marginLeft: 5,
            boxShadow: "0px 8px 16px 0px rgba(0, 0, 0, 0.2)",
            zIndex: "5",
          }}
        >
          {!showForm &&
            Object.keys(options).map((option, index) => (
              <div style={{ padding: 10 }}>
                <a
                  key={index}
                  href={options[option]}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {option}
                </a>
                {index < options.length ? <hr /> : null}
              </div>
            ))}
          {showForm && (
            <div style={{ marginTop: 10 }}>
              <div
                style={{ color: "#000000", fontSize: 12, paddingBottom: 10 }}
              >
                Unsure where to start?{" "}
                <span
                  style={{ cursor: "pointer", color: color }}
                  onClick={() => {
                    openInNewTab("https://sustainabilityreports.com/");
                  }}
                >
                  Try here!
                </span>
              </div>
              <input
                type="text"
                className="textinput"
                placeholder="Year (e.g., 2024)"
                value={year}
                onChange={(e) => setYear(e.target.value)}
                style={{
                  width: 170,
                  borderRadius: 8,
                  borderColor: "#000000",
                  borderWidth: 1,
                  padding: 5,
                  fontSize: 12,
                }}
              />
              <div style={{ display: "flex" }}>
                <label for="browse-files">
                  <div
                    style={{
                      ...style,
                      width: 50,
                      fontSize: 12,
                      margin: 10,
                      marginRight: 0,
                      borderTopRightRadius: 0,
                      borderBottomRightRadius: 0,
                      border: "none",
                      cursor: "pointer",
                    }}
                  >
                    Browse
                  </div>
                </label>
                <input
                  id="browse-files"
                  type="file"
                  accept="application/pdf"
                  onChange={(e) => setSelectedFile(e.target.files[0])}
                />
                <div
                  style={{
                    color: "#000000",
                    overflowX: "scroll",
                    overflowY: "hidden",
                    fontSize: 12,
                    border: "solid 1px #000000",
                    backgroundColor: "#efefef",
                    padding: 15,
                    paddingLeft: 5,
                    paddingRight: 0,
                    paddingTop: 0,
                    margin: 10,
                    marginLeft: 0,
                    borderTopRightRadius: 8,
                    borderBottomRightRadius: 8,
                    height: 17,
                    flex: 1,
                  }}
                >
                  <div
                    style={{
                      alignSelf: "center",
                      textAlign: "left",
                      display: "flex",
                      flexDirection: "row",
                      width: selectedFile?.name.length * 6,
                    }}
                  >
                    <p>{selectedFile?.name}</p>
                  </div>
                </div>
              </div>

              <button
                style={{
                  ...style,
                  cursor: "pointer",
                  backgroundColor: color,
                  width: 180,
                  marginBottom: 10,
                  paddinTop: 20,
                  paddingBottom: 22.5,
                  height: 100,
                }}
                onClick={handleUpload}
              >
                Upload!
              </button>
              {uploading && progress > 0 ? (
                <div
                  style={{ fontSize: 10, color: "#000000", paddingBottom: 10 }}
                >
                  Uploading: {progress}%
                </div>
              ) : null}
            </div>
          )}
          <button
            onClick={() => setShowForm(!showForm)}
            style={{
              ...style,
              cursor: "pointer",
              backgroundColor: color,
              borderTopLeftRadius: 0,
              borderTopRightRadius: 0,
              paddinTop: 20,
              paddingBottom: 22.5,
              height: 100,
            }}
          >
            {showForm ? "Cancel" : "Add A Report!"}
          </button>
        </div>
      )}
    </div>
  );
};

export default DropdownButton;
